export const APP_NAME = 'atlas';
